import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { AuthContext } from './Firebase/AuthProvider';
import close from './assets/icon/close_no_bg.png';
import arr from './assets/icon/Rarrow.png';
import logo_m from './assets/logo/logo_slider.svg';
import acc from './assets/acc.svg';

const menuStructure = [
  { title: 'Home', path: '/' },
  {
    title: 'Collections',
    children: [
      { title: 'Custom Clothing', path: '/' },
      { title: "Designer's Exclusive", path: '/products' },
      { title: 'Fabric Experience', path: '/feel' },
    ],
  },
  {
    title: 'Services',
    children: [
      { title: 'Get Quotation', path: '/reachus/getQuotation' },
      { title: 'Request Exhibition', path: '/reachus/appointment' },
    ],
  },
  {
    title: 'Account',
    children: [
      { title: 'My Profile', path: '/profile' },
      { title: 'Shopping Cart', path: '/cart' },
      { title: 'Register', path: '/register' },
    ],
  },
  {
    title: 'Company',
    children: [
      { title: 'About Us', path: '/contact' },
      { title: 'Contact Us', path: '/reachus/general' },
    ],
  },
];

export default function SidebarNav({ sidebar, setSideBar }) {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [menuStack, setMenuStack] = useState([menuStructure]);
  const [direction, setDirection] = useState(1);

  useEffect(() => {
    if (!sidebar) {
      const timer = setTimeout(() => {
        setMenuStack([menuStructure]);
        setDirection(1);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [sidebar]);

  const currentMenu = menuStack[menuStack.length - 1];

  const pushMenu = (items) => {
    setDirection(1);
    setMenuStack([...menuStack, items]);
  };

  const popMenu = () => {
    if (menuStack.length > 1) {
      setDirection(-1);
      setMenuStack(menuStack.slice(0, -1));
    }
  };

  const handleItemClick = (item) => {
    if (item.children) {
      pushMenu(item.children);
    } else if (item.path) {
      navigate(item.path);
      setSideBar(false);
    }
  };

  const variants = {
    enter: (direction) => ({ x: direction > 0 ? '100%' : '-100%', opacity: 0 }),
    center: { x: 0, opacity: 1 },
    exit: (direction) => ({ x: direction > 0 ? '-100%' : '100%', opacity: 0 }),
  };

  return (
    <div
      className={`nav_sidebar ${
        sidebar ? 'nav_sidebar_open' : 'nav_sidebar_close'
      } sidebar-container`}
    >
      <div className="sidebar-header">
        <div className="flex items-center gap-4 absolute left-4">
          {menuStack.length > 1 && (
            <button
              onClick={popMenu}
              className="sidebar-btn p-0"
              aria-label="Back"
            >
              <img
                src={arr}
                alt="Back"
                className="sidebar-icon"
                style={{ transform: 'rotate(180deg)' }}
              />
            </button>
          )}
          <img src={logo_m} alt="Logo" className="sidebar-logo" />
        </div>

        <button
          onClick={() => setSideBar(false)}
          className="sidebar-btn absolute right-4"
          aria-label="Close"
        >
          <img src={close} alt="Close" className="sidebar-icon close-icon" />
        </button>
      </div>

      <div className="sidebar-menu-container">
        <AnimatePresence initial={false} custom={direction} mode="popLayout">
          <motion.div
            key={menuStack.length}
            custom={direction}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
            className="sidebar-scroll-area"
          >
            {currentMenu.map((item, index) => (
              <motion.div
                key={index}
                onClick={() => handleItemClick(item)}
                className="sidebar-menu-item"
                whileHover={{ x: 5 }}
              >
                <span className="sidebar-menu-text">{item.title}</span>
                {item.children && (
                  <img src={arr} alt="Arrow" className="sidebar-arrow" />
                )}
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="sidebar-footer">
        <div
          className="sidebar-account"
          onClick={() => {
            if (user) navigate('/profile');
            else navigate('/login');
            setSideBar(false);
          }}
        >
          <img src={acc} alt="" className="sidebar-account-icon" />
          <span className="sidebar-account-text">
            {user
              ? user.displayName || user.email?.split('@')[0] || 'My Account'
              : 'Login / Register'}
          </span>
        </div>
      </div>
    </div>
  );
}
